import api from '../../api'
import type { selectRes } from '../../features/workspace/sidebar/SideBarTypes'

// Same per-type endpoint every single-item delete flow already calls
// (FileCardOptionsPopup, FileExplorerTab's right-click menu) — consolidated
// here so multi-select delete doesn't reinvent the branching.
export const deleteResource = async (roomId: string, item: selectRes): Promise<void> => {
    if (item.resType === 'snippet') {
        await api.delete(`/snippets/${item.id}/room/${roomId}`);
    } else if (item.resType === 'file') {
        await api.delete(`/rooms/${roomId}/${item.id}/files`);
    } else {
        await api.delete(`/rooms/${roomId}/folders/${item.id}/delete`);
    }
};

export type DeleteResourcesResult = {
    deletedIds: string[];
    failedIds: string[];
};

// Deletes each item one at a time so one failure doesn't block the rest —
// callers pre-filter to items the current user is permitted to delete
// (folder permission edge cases are intentionally out of scope here: a
// folder is deletable or not based on its own creator/permissions, its
// contents are never inspected).
export const deleteResources = async (
    roomId: string,
    items: selectRes[]
): Promise<DeleteResourcesResult> => {
    const deletedIds: string[] = [];
    const failedIds: string[] = [];

    for (const item of items) {
        try {
            await deleteResource(roomId, item);
            deletedIds.push(item.id);
        } catch {
            failedIds.push(item.id);
        }
    }

    return { deletedIds, failedIds };
};
